import { scaleThreshold as scale } from 'd3-scale'

const range = [{
              clazz: 'x-small',
              singleSerieOuterRadius: 3,
              singleSerieInnerRadius: 0,
              multiSerieRadius: 2
            }, {
              clazz: 'small',
              singleSerieOuterRadius: 4,
              singleSerieInnerRadius: 0,
              multiSerieRadius: 2.5
            }, {
              clazz: 'medium',
              singleSerieOuterRadius: 6.5,
              singleSerieInnerRadius: 1.8,
              multiSerieRadius: 3.5
            }, {
              clazz: 'default',
              singleSerieOuterRadius: 8.5,
              singleSerieInnerRadius: 2.5,
              multiSerieRadius: 4.5
            }],
      rScale = scale().domain([7, 15, 50])
                            .range(range)

/*
 * Controls how we draw a line with points based on the size of the graph
 * and how many points on the X axis we're showing for one serie. The argument
 * passed into the scale function is a magic number where the average chart has
 a number of around 100.
 */
export default function (width, height, numPoints) {
  return rScale((width * height) / (numPoints * 100)) || range[0] // if the size < out defined domain, use the smallest setting
}
